import React from 'react';
import { motion } from 'framer-motion';
import { FaClock, FaUser } from 'react-icons/fa';

const VideoInfo = ({ videoData }) => {
  if (!videoData) return null;

  const formatDuration = (seconds) => {
    if (!seconds) return 'N/A';
    
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hrs > 0) {
      return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-3xl mx-auto mb-8 bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl overflow-hidden shadow-2xl"
    >
      {videoData.thumbnail && (
        <div className="relative">
          <img
            src={videoData.thumbnail}
            alt={videoData.title}
            className="w-full h-64 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent" />
        </div>
      )}
      
      <div className="p-6">
        <h2 className="text-2xl font-bold text-white mb-3 line-clamp-2">
          {videoData.title}
        </h2>
        
        <div className="flex items-center gap-6 text-gray-400">
          {videoData.uploader && (
            <div className="flex items-center gap-2">
              <FaUser />
              <span>{videoData.uploader}</span>
            </div>
          )}
          
          {videoData.duration && (
            <div className="flex items-center gap-2">
              <FaClock />
              <span>{formatDuration(videoData.duration)}</span>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default VideoInfo;
